import { render, staticRenderFns } from "./SendMessageToAdmin.vue?vue&type=template&id=3cf565ed&scoped=true&"
import script from "./SendMessageToAdmin.vue?vue&type=script&lang=js&"
export * from "./SendMessageToAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf565ed",
  null
  
)

export default component.exports